;
(function(){
  var playBtn = document.getElementById("om-play-btn");
  var vid = document.getElementById("om-vid");
  if (!playBtn || !vid) return;
  function startVideo() {
    vid.muted = false;
    vid.play();
    playBtn.style.display = "none";
    vid.setAttribute("controls", "");
  }
  playBtn.addEventListener("click", startVideo);
  vid.addEventListener("click", function() {
    if (playBtn.style.display !== "none") { startVideo(); }
  });
})();

;
(function(){
  var sticky = document.getElementById('om-sticky-bar');
  if (!sticky) return;
  var shown = false;
  function checkScroll() {
    var scrollPct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
    if (scrollPct > 0.20 && !shown) {
      sticky.classList.add('om-sticky--visible');
      shown = true;
    } else if (scrollPct <= 0.15 && shown) {
      sticky.classList.remove('om-sticky--visible');
      shown = false;
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
})();
